import {
  CHANGE_FILTER_STATE,
  LOAD_USERS,
  LOAD_USERS_FAILED,
  LOAD_USERS_SUCCESS,
} from './users-actions'

import { createReducer } from 'redux-act'
import { UserProfile } from 'types/userTypes'
import { UsersFilterState } from '../components/types'
import { filterInitialState } from './users-constants'

type UsersState = {
  users: UserProfile[]
  filteredUsers: UserProfile[]
  userInfo: string
  isLoading: boolean
  loadUsersError: string
  userFilters: UsersFilterState
  count: number
}

export const usersReducer = createReducer(
  {
    [CHANGE_FILTER_STATE.getType()]: (state, payload) => {
      return {
        ...state,
        userFilters: payload?.userFilters || filterInitialState,
      }
    },
    [LOAD_USERS.getType()]: (state, payload) => {
      return {
        ...state,
        loadUsersError: '',
      }
    },
    [LOAD_USERS_SUCCESS.getType()]: (state, payload) => {
      const { users = [], count = 0 } = payload

      return {
        ...state,
        users,
        count,
        isLoading: false,
        loadUsersError: '',
        userInfo: '',
      }
    },
    [LOAD_USERS_FAILED.getType()]: (state, payload) => {
      return {
        ...state,
        loadUsersError: payload.message,
        isLoading: false,
      }
    },
  },
  {
    users: [],
    filteredUsers: [],
    userInfo: '',
    isLoading: true,
    loadUsersError: '',
    userFilters: filterInitialState,
    count: 0,
  } as UsersState
)
